import React, { useEffect, useState } from "react";
import AddDetails from "./AddDetails";
import brandingKitAPI from "../../../api/admin/brandingKitApi";
import { Link, useLocation, useParams } from "react-router-dom";
import DragDropMultiUpload from "../../../layout/admin/partials/DragDropMultiUpload";
import Auth from "../../../utils/AuthUtils";
import { showError, showSuccess } from "../../../utils/toastUtils";

function BrandingKit() {
  const { id } = useParams();
  const location = useLocation();

  const [albums, setAlbums] = useState([]);
  const [uploadedfiles, setUploadedFiles] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  const role = Auth.getUserDetails("roles");

  useEffect(() => {
    if (!id) {
      fetchBrandingAlbum();
    } else {
      setAlbums([]);
    }

    fetchBrandingFiles();
  }, [location.pathname]);

  const fetchBrandingAlbum = async () => {
    const res = await brandingKitAPI.getFolder();

    if (res.code === 200) {
      setAlbums(res.data);
    } else {
      setAlbums([]);
    }
  };

  const fetchBrandingFiles = async () => {
    const payload = {
      albumId: id || "",
    };

    const res = await brandingKitAPI.getFiles(payload);

    if (res.code === 200) {
      setUploadedFiles(res.data);
    } else {
      setUploadedFiles([]);
    }
  };

  const handleUploadFile = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      if (!files) {
        setLoading(false);
        showError("No File Selected");
        return;
      }

      const form = new FormData();

      if (id) {
        form.append("albumId", id);
      }

      files.forEach((f, i) => {
        form.append("files[]", f);
      });

      const res = await brandingKitAPI.uploadFile(form, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.code === 200) {
        showSuccess(res.message);

        if (!id) {
          fetchBrandingAlbum();
        }
        fetchBrandingFiles();
        setIsOpen(false);
      } else {
        showError(res.message);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      showError(err.message);
    }
  };

  const getFileIcon = (fileName, path) => {
    if (!fileName) {
      return "/icons/unknown.png"; // default icon
    }

    const ext = fileName.split(".").pop().toLowerCase();

    switch (ext) {
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
      case "webp":
        return path;
      case "pdf":
        return "/img/files/pdf.png";
      case "doc":
      case "docx":
        return "/img/files/doc.png";
      case "xls":
      case "xlsx":
        return "/img/files/xlsx.png";
      case "ppt":
      case "pptx":
        return "/img/files/ppt.png";
      case "txt":
        return "/img/files/txt.jpg";
      case "zip":
      case "rar":
        return "/img/files/zip.png";
      default:
        return "/img/files/unknown.png"; // fallback
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-flex align-items-center justify-content-between gap-2 mb-4 flex-wrap">
          <div>
            <h4 className="mb-1">Branding Kit</h4>
            <h6 className="text-muted">
              View, and manage branding kits available in your system.
            </h6>
          </div>

          {role === "superadmin" && (
            <div className="gap-2 d-flex align-items-center flex-wrap">
              {isOpen ? (
                <button
                  className="btn btn-danger mt-2 mt-md-0"
                  type="button"
                  onClick={(e) => setIsOpen(false)}
                >
                  <i className="ti ti-circle-plus me-1" />
                  Close File Uploader
                </button>
              ) : (
                <button
                  className="btn btn-primary mt-2 mt-md-0"
                  type="button"
                  onClick={(e) => setIsOpen(true)}
                >
                  <i className="ti ti-circle-plus me-1" />
                  Add File
                </button>
              )}

              {!id && (
                <button
                  className="btn btn-primary mt-2 mt-md-0"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#add_folder"
                >
                  <i className="ti ti-circle-plus me-1" />
                  Add Folder
                </button>
              )}
            </div>
          )}
        </div>

        {isOpen && (
          <form method="post" onSubmit={handleUploadFile}>
            <DragDropMultiUpload
              onChange={(selectedFiles) => setFiles(selectedFiles)}
            />

            <div className="row">
              <div className="col-md-12 text-center">
                <button type="submit" className="btn btn-primary">
                  Upload
                </button>
              </div>
            </div>
          </form>
        )}

        <div className="row row-cols-xxl-6 row-cols-xl-3 row-cols-sm-3 row-cols-1 mt-5">
          {albums.length > 0 &&
            albums.map((item, index) => (
              <div className="col d-flex" key={item._id}>
                <div className="card access-wrap flex-fill">
                  <div className="card-body text-center">
                    <Link to={`/admin/branding-kit/${item._id}`}>
                      <img
                        src="https://axepert.in/khel-mahotsav/backend/assets/img/icons/folder-icon.svg"
                        style={{ width: "80px" }}
                        alt="img"
                        className="mb-3"
                      />
                      <h6 className="mb-2 fw-medium">{item.albumTitle}</h6>
                    </Link>
                  </div>
                </div>
              </div>
            ))}

          {uploadedfiles.length > 0 &&
            uploadedfiles.map((item, index) => (
              <div className="col d-flex" key={item._id}>
                <div className="card access-wrap flex-fill">
                  <div className="card-body text-center">
                    <a href={item.path} target="_blank">
                      <img
                        src={getFileIcon(item.originalName, item.path)}
                        style={{ width: "80px" }}
                        alt="icon"
                      />
                      <h6 className="fw-medium">{item.originalName}</h6>
                    </a>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>

      <div className="modal fade" id="add_folder">
        <AddDetails />
      </div>
    </div>
  );
}

export default BrandingKit;
